const colors = {
  transparent: 'transparent',
  current: 'currentColor',
  link: {
    DEFAULT: '#179EEE',
  },
  white: {
    DEFAULT: '#FFFFFF',
  },
  black: {
    DEFAULT: '#000000',
  },
  primary: {
    dark: '#0234E1',
    DEFAULT: '#1774F0',
    light: '#8AB9F7',
    lightness: '#1774f01a', // DEFAULT/0.1
  },
  secondary: {
    dark: '#111122',
    DEFAULT: '#18182E',
    light: '#8B8B96',
  },
  success: {
    dark: '#00B670',
    DEFAULT: '#03D8A9',
    light: '#9AEFDC',
  },
  danger: {
    dark: '#D1160E',
    DEFAULT: '#E74C3C',
    light: '#F5B7B1',
  },
  warning: {
    dark: '#E14C00',
    DEFAULT: '#F08C00',
    light: '#F9D199',
  },
  gray: {
    black: '#1E2535',
    dark: '#5D7186',
    DEFAULT: '#9DA9B6',
    light: '#DDE5ED',
    lightest: '#F4F7F9',
    lightness: '#fafbfc', // DEFAULT/0.5
  },
};

export default colors;
